<script>
  import { onMount } from "svelte";

  export let loadAsync = true;
  export let blocking = true;

  onMount(() => {
    window.instgrm && window.instgrm.Embeds.process();
    window.FB && window.FB.XFBML.parse();
    window.twttr && window.twttr.widgets.load();
  });
</script>

<svelte:head>
  <script async={loadAsync} src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
  <script
    id="facebook-of"
    async={loadAsync}
    defer={blocking}
    crossorigin="anonymous"
    src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v15.0"
    nonce="D1ZbbVhD"
  ></script>
  <script
    id="instagram"
    async={loadAsync}
    defer={blocking}
    src="https://www.instagram.com/embed.js"
  ></script>
</svelte:head>

<div id="fb-root" />
